declare namespace $ {

	type $mol_string__type_shm_hitalama_teams_token_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams_token['type'] >
		,
		ReturnType< $mol_string['type'] >
	>
	type $mol_string__hint_shm_hitalama_teams_token_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams_token['hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_teams_token_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams_token['value'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_teams_token_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams_token['submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__enabled_shm_hitalama_teams_token_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams_token['enabled'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__autocomplete_native_shm_hitalama_teams_token_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['autocomplete_native'] >
	>
	export class $shm_hitalama_teams_token extends $mol_password {
		hint( ): string
		value( next?: string ): string
		submit( next?: any ): any
		enabled( ): boolean
		Pass( ): $mol_string
	}
	
	type $mol_string__value_shm_hitalama_teams_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['new_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_teams_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['New_name'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_shm_hitalama_teams_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['new_api_url'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_teams_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__autocomplete_native_shm_hitalama_teams_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['autocomplete_native'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['New_api_url'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_hitalama_teams_token__value_shm_hitalama_teams_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['new_api_token'] >
		,
		ReturnType< $shm_hitalama_teams_token['value'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['New_api_token'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_status__message_shm_hitalama_teams_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_create_status'] >
		,
		ReturnType< $mol_status['message'] >
	>
	type $mol_status__style_shm_hitalama_teams_14 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_teams['team_create_status_color'] >,
		}) 
		,
		ReturnType< $mol_status['style'] >
	>
	type $mol_button_major__title_shm_hitalama_teams_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_hitalama_teams_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_create_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_hitalama_teams_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_form__form_fields_shm_hitalama_teams_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_shm_hitalama_teams_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_list__rows_shm_hitalama_teams_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_picker_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_pick__align_hor_shm_hitalama_teams_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align_hor'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_teams_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_teams_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_link__uri_shm_hitalama_teams_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_tab_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_teams_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_hitalama_teams_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_tab_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__uri_shm_hitalama_teams_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_tab_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_teams_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_hitalama_teams_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_tab_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__uri_shm_hitalama_teams_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_tab_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_teams_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__current_shm_hitalama_teams_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_tab_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_list__rows_shm_hitalama_teams_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_string__value_shm_hitalama_teams_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_team_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_shm_hitalama_teams_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_manage_allowed'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['Team_name'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_string__value_shm_hitalama_teams_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_team_api_url'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_shm_hitalama_teams_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_manage_allowed'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_string__autocomplete_native_shm_hitalama_teams_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['autocomplete_native'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['Team_api_url'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_hitalama_teams_token__value_shm_hitalama_teams_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_team_api_token'] >
		,
		ReturnType< $shm_hitalama_teams_token['value'] >
	>
	type $shm_hitalama_teams_token__enabled_shm_hitalama_teams_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_manage_allowed'] >
		,
		ReturnType< $shm_hitalama_teams_token['enabled'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['Team_api_token'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_text__text_shm_hitalama_teams_47 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_team_creator'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_49 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['Team_creator'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_form__form_fields_shm_hitalama_teams_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_shm_hitalama_teams_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_string__value_shm_hitalama_teams_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_teams_53 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__enabled_shm_hitalama_teams_54 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_manage_allowed'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_button_major__title_shm_hitalama_teams_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_hitalama_teams_56 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_add_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_hitalama_teams_57 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_teams_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_status__style_shm_hitalama_teams_59 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_teams['member_add_status_color'] >,
		}) 
		,
		ReturnType< $mol_status['style'] >
	>
	type $mol_status__message_shm_hitalama_teams_60 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_add_status'] >
		,
		ReturnType< $mol_status['message'] >
	>
	type $mol_view__sub_shm_hitalama_teams_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_62 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_teams_65 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_hitalama_teams_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_hitalama_teams_67 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $shm_hitalama_profile_badge__name_shm_hitalama_teams_68 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_name'] >
		,
		ReturnType< $shm_hitalama_profile_badge['name'] >
	>
	type $shm_hitalama_profile_badge__avatar_uri_shm_hitalama_teams_69 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_avatar_uri'] >
		,
		ReturnType< $shm_hitalama_profile_badge['avatar_uri'] >
	>
	type $mol_link__uri_shm_hitalama_teams_70 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_teams_71 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_name'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_hitalama_teams_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_hitalama_teams_74 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_teams_75 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_admin'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_hitalama_teams_76 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['member_admin_enabled'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_text__text_shm_hitalama_teams_77 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_member_name'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_78 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_79 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['Selected_member_name'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_text__text_shm_hitalama_teams_80 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_member_user_id'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_form_field__name_shm_hitalama_teams_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_teams_82 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['Selected_member_id'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_view__sub_shm_hitalama_teams_83 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_84 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_85 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_86 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_87 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_88 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_89 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_teams_90 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['permission_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_hitalama_teams_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_92 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_93 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_box__title_shm_hitalama_teams_94 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_teams_95 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['project_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_hitalama_teams_96 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['permission_manage_allowed'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__title_shm_hitalama_teams_97 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_teams_98 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['project_prerelease'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_hitalama_teams_99 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['permission_manage_allowed'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__title_shm_hitalama_teams_100 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_teams_101 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['project_release'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_hitalama_teams_102 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['permission_manage_allowed'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $shm_hitalama_guide_page__title_shm_hitalama_teams_103 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_page['title'] >
	>
	type $shm_hitalama_guide_page__help_section_shm_hitalama_teams_104 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_page['help_section'] >
	>
	type $shm_hitalama_guide_page__body_shm_hitalama_teams_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_guide_page['body'] >
	>
	type $shm_hitalama_guide_page__title_shm_hitalama_teams_106 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_team_name'] >
		,
		ReturnType< $shm_hitalama_guide_page['title'] >
	>
	type $shm_hitalama_guide_page__help_section_shm_hitalama_teams_107 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_page['help_section'] >
	>
	type $shm_hitalama_guide_page__tools_shm_hitalama_teams_108 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_guide_page['tools'] >
	>
	type $shm_hitalama_guide_page__body_shm_hitalama_teams_109 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_guide_page['body'] >
	>
	type $mol_link__uri_shm_hitalama_teams_110 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_new_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_teams_111 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__click_shm_hitalama_teams_112 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_new_click'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_select__dictionary_shm_hitalama_teams_113 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_teams_114 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['team_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_page__title_shm_hitalama_teams_115 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_team_tab_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_teams_116 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['detail_content'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_hitalama_teams_117 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_teams_118 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_hitalama_teams_119 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_teams_120 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_hitalama_teams_121 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_hitalama_teams_122 = $mol_type_enforce<
		ReturnType< $shm_hitalama_teams['selected_member_name'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_teams_123 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_hitalama_teams_124 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_teams extends $mol_book2 {
		team_pages( ): readonly(any)[]
		new_name( next?: string ): string
		New_name( ): $mol_string
		New_name_field( ): $mol_form_field
		new_api_url( next?: string ): string
		New_api_url( ): $mol_string
		New_api_url_field( ): $mol_form_field
		new_api_token( next?: string ): string
		New_api_token( ): $shm_hitalama_teams_token
		New_api_token_field( ): $mol_form_field
		team_create_status( ): string
		team_create_status_color( ): string
		New_status( ): $mol_status
		team_create_enabled( ): boolean
		team_create( next?: any ): any
		New_submit( ): $mol_button_major
		New_form( ): $mol_form
		selected_team_name( next?: string ): string
		Team_picker_icon( ): $mol_icon_dots_vertical
		team_picker_rows( ): readonly(any)[]
		Team_picker_options( ): $mol_list
		Team_picker( ): $mol_pick
		team_tab_uri( id: any): string
		team_tab_current( id: any): boolean
		Team_info_link( ): $mol_link
		Team_members_link( ): $mol_link
		Team_maps_link( ): $mol_link
		Team_menu( ): $mol_list
		team_new_uri( ): string
		team_new_click( next?: any ): any
		team_options( ): Record<string, any>
		team_id( next?: string ): string
		selected_team_tab_title( ): string
		detail_content( ): readonly($mol_view)[]
		team_manage_allowed( ): boolean
		Team_name( ): $mol_string
		Team_name_field( ): $mol_form_field
		selected_team_api_url( next?: string ): string
		Team_api_url( ): $mol_string
		Team_api_url_field( ): $mol_form_field
		selected_team_api_token( next?: string ): string
		Team_api_token( ): $shm_hitalama_teams_token
		Team_api_token_field( ): $mol_form_field
		selected_team_creator( ): string
		Team_creator( ): $mol_text
		Team_creator_field( ): $mol_form_field
		Settings_form( ): $mol_form
		member_id( next?: string ): string
		Member_id( ): $mol_string
		member_add_enabled( ): boolean
		member_add( next?: any ): any
		Member_add( ): $mol_button_major
		Member_add_row( ): $mol_view
		member_add_status_color( ): string
		member_add_status( ): string
		Member_add_status( ): $mol_status
		Member_name_head( ): $mol_view
		Member_id_head( ): $mol_view
		Member_admin_head( ): $mol_view
		Members_head( ): $mol_view
		member_rows( ): readonly(any)[]
		Member_rows( ): $mol_list
		Members( ): $mol_view
		Team_maps_empty( ): $mol_text
		member_uri( id: any): string
		member_name( id: any): string
		member_avatar_uri( id: any): string
		Member_badge( id: any): $shm_hitalama_profile_badge
		Member_name( id: any): $mol_link
		member_user_id( id: any): string
		Member_user_id( id: any): $mol_view
		member_admin( id: any, next?: boolean ): boolean
		member_admin_enabled( id: any): boolean
		Member_admin( id: any): $mol_check_box
		selected_member_name( ): string
		Selected_member_name( ): $mol_text
		Selected_member_name_field( ): $mol_form_field
		selected_member_user_id( ): string
		Selected_member_id( ): $mol_text
		Selected_member_id_field( ): $mol_form_field
		Member_meta( ): $mol_view
		Permissions_title( ): $mol_view
		Project_head( ): $mol_view
		Visible_head( ): $mol_view
		Prerelease_head( ): $mol_view
		Release_head( ): $mol_view
		Permission_head( ): $mol_view
		permission_rows( ): readonly(any)[]
		Permission_rows( ): $mol_list
		Permissions( ): $mol_view
		Member_detail( ): $mol_view
		project_title( id: any): string
		Project_title( id: any): $mol_view
		project_visible( id: any, next?: boolean ): boolean
		permission_manage_allowed( ): boolean
		Project_visible( id: any): $mol_check_box
		project_prerelease( id: any, next?: boolean ): boolean
		Project_prerelease( id: any): $mol_check_box
		project_release( id: any, next?: boolean ): boolean
		Project_release( id: any): $mol_check_box
		menu_title( ): string
		pages( ): ReturnType< $shm_hitalama_teams['team_pages'] >
		New_page( ): $shm_hitalama_guide_page
		Team_menu_page( ): $shm_hitalama_guide_page
		Team_create_link( ): $mol_link
		Team_select( ): $mol_select
		Detail_page( ): $mol_page
		Info( ): $mol_view
		Members_section( ): $mol_view
		Team_maps( ): $shm_hitalama_teams_maps
		Team_maps_empty_page( ): $mol_page
		Member_row( id: any): $mol_view
		Member_page( ): $mol_page
		Permission_row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=teams.view.tree.d.ts.map